<div class="recorder_modal create-recorder-heatmap confirmation_modal">
  <p class="recorder_modal_title">{{ header }}</p>
  <div class="recorder_modal_text" *ngIf="!data?.isContentHTML">
    {{ content }}
  </div>
  <div
    class="recorder_modal_text"
    *ngIf="data?.isContentHTML"
    [innerHTML]="data?.content"
  ></div>

  <div class="confirmation_input_container" *ngIf="data.confirmationInput">
    <label class="custom-input_field_withoutIcon">
      <span class="custom-input_field-label">
        Please write <span>{{ data.target }}</span> to confirm
      </span>
      <input
        class="custom-input_field"
        matInput
        type="text"
        [(ngModel)]="confirmationInputString"
      />
    </label>
  </div>

  <div class="button_container">
    <ng-container *ngIf="data.confirmOnly">
      <button
        mat-raised-button
        class="primary"
        (click)="this.dialogRef.close(1)"
        #btnFocus="matButton"
        [autofocus]="btnFocus.focus()"
        [class.secondary-style]="confirmButtonDangerStyle"
      >
        {{ confirmButtonDangerStyle ? confirm_btn : "OK" }}
      </button>
    </ng-container>
    <ng-container *ngIf="!data.confirmOnly">
      <button
        mat-raised-button
        (click)="this.dialogRef.close(2)"
        class="seo_cancel"
      >
        {{ cancel_btn }}
      </button>
      <button
        mat-raised-button
        class="primary"
        (click)="this.dialogRef.close(1)"
        #btnFocus="matButton"
        [autofocus]="!data.confirmationInput ? btnFocus.focus() : false"
        [class.secondary-style]="confirmButtonDangerStyle"
        [disabled]="
          data.confirmationInput &&
          confirmationInputString != data.confirmationInputValue
        "
      >
        {{ confirm_btn }}
      </button>
    </ng-container>
  </div>
</div>
<!-- <h1 mat-dialog-title>{{ this.data.header }}</h1>
<div mat-dialog-content>
  <p>{{ this.data.content }}</p>
</div>
<div mat-dialog-actions style="float: right">
  <button mat-button (click)="this.dialogRef.close(1)" cdkFocusInitial>
    Yes
  </button>
  <button mat-button (click)="this.dialogRef.close(2)">Cancel</button>
</div> -->
